var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"editorContent",staticClass:"editor-content",style:({
		width: (_vm.width + "px"),
		height: ((_vm.width/16*9) + "px"),
		top: (_vm.top + "px"),
		left: (_vm.left + "px")
	})},[_c('EditorPlay',{style:({
		transform: ("scale(" + (_vm.width / 1920) + ")")
	})})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01239032","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/draftPreview/EditorContent.vue
// module id = null
// module chunks = 